import { render } from "./topbanner.vue?vue&type=template&id=8b37a2a2"
import script from "./topbanner.vue?vue&type=script&lang=js"
export * from "./topbanner.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__